import { createSortOption } from "@nosto/preact"
export const sizes = [24, 48, 72]

export const sortOptions = [
    createSortOption("score", "Featured", { field: "score", order: "desc" }),
    createSortOption("buys", "Best selling", { field: "stats.buys", order: "desc" }),
    createSortOption("name", "Alphabetically, A-Z", { field: "name", order: "asc" }),
    createSortOption("-name", "Alphabetically, Z-A", { field: "name", order: "desc" }),
    createSortOption("price", "Price low to high", { field: "price", order: "asc" }),
    createSortOption("-price", "Price high to low", { field: "price", order: "desc" }),
    createSortOption("-date", "Date, old to new", { field: "datePublished", order: "asc" }),
    createSortOption("date", "Date, new to old", { field: "datePublished", order: "desc" }),
]

export const defaultConfig = {
    sort: sortOptions[0],
    serpSize: sizes[0],
    autocompleteProductsSize: 4,
    autocompleteKeywordsSize: 5,
    historySize: 5
}

export const NORESULTS_RECID = "noresults-nosto-1";
export const HISTORY_DROPDOWN_REC_ID = "searchdropdown-nosto-1";

export const popularSearches = [
    "Short Hair",
    "Thick Hair",
    "Add Volume",
]

export const isUS = window.Shopify?.country === "US";